<!-- eslint-disable vue/no-parsing-error -->
<template>
    <b-card>
        <div class="form-group">
            <label for="image">Image:</label><br>
            <b-form-file id="image" accept=".jpg, .jpeg, .png, .webp" @change="changeImage" />
            <div class="mt-25" v-if="previewImage">
                <b-img height="100" :src="previewImage" rounded :alt="`Preview Image`"
                    class="d-inline-block mr-25 border" />
            </div>
            <div class="alert alert-info p-1 mt-25">
                <strong>Notes</strong>
                <ul>
                    <li>Maximum file size is 2MB</li>
                </ul>
            </div>
        </div>

        <b-card class="border" title="Thumbnail Detail">
             <div class="form-group">
                <label for="thumbnail_description">Description:</label>
                <b-form-input id="thumbnail_description" v-model="formPayload.thumbnail_description" type="text" class="form-control"
                    :class="validations.hasOwnProperty('thumbnail_description') && validations.thumbnail_description.length > 0 ? 'is-invalid' : ''"
                    placeholder="Thumbnail Description" />
                <small v-if="validations.hasOwnProperty('thumbnail_description') && validations.thumbnail_description.length > 0" class="text-danger">
                    {{ validations.thumbnail_description.join(', ') }}
                </small>
            </div>

            <div class="form-group">
                <label for="thumbnail_source">Source:</label>
                <b-form-input id="thumbnail_source" v-model="formPayload.thumbnail_source" type="text" class="form-control"
                    :class="validations.hasOwnProperty('thumbnail_source') && validations.thumbnail_source.length > 0 ? 'is-invalid' : ''"
                    placeholder="Thumbnail Source" />
                <small v-if="validations.hasOwnProperty('thumbnail_source') && validations.thumbnail_source.length > 0" class="text-danger">
                    {{ validations.thumbnail_source.join(', ') }}
                </small>
            </div>

            <div class="form-group">
                <label for="thumbnail_author">Author:</label>
                <b-form-input id="thumbnail_author" v-model="formPayload.thumbnail_author" type="text" class="form-control"
                    :class="validations.hasOwnProperty('thumbnail_author') && validations.thumbnail_author.length > 0 ? 'is-invalid' : ''"
                    placeholder="Thumbnail Author" />
                <small v-if="validations.hasOwnProperty('thumbnail_author') && validations.thumbnail_author.length > 0" class="text-danger">
                    {{ validations.thumbnail_author.join(', ') }}
                </small>
            </div>
        </b-card>

        <div class="form-group" v-if="formPayload.content_type === 'video'">
            <label for="video">Video:</label><br>
            <b-form-file id="video" accept=".mp4, .mkv, .mpeg, .mov, .3gp" @change="changeVideo" />
            <div class="alert alert-info p-1 mt-25">
                <strong>Notes</strong>
                <ul>
                    <li>Maximum file size is 10MB</li>
                </ul>
            </div>
        </div>

        <div class="form-group">
            <label for="title">Title: (Max: 500 characters)<span class="text-danger">*</span></label>
            <b-form-input id="title" v-model="formPayload.title" type="text" class="form-control"
                :class="validations.hasOwnProperty('title') && validations.title.length > 0 ? 'is-invalid' : ''"
                placeholder="title" @input="validateTitle" />
            <!-- Character counter -->
            <small class="text-muted">
                {{ formPayload.title ? formPayload.title.length : 0 }}/500 characters
            </small>
            <br />
            <small v-if="validations.hasOwnProperty('title') && validations.title.length > 0" class="text-danger">
                {{ validations.title.join(', ') }}
            </small>
        </div>

        <div class="form-group">
            <label for="excerpt">Excerpt: <span class="text-danger">*</span></label>
            <b-form-input id="excerpt" v-model="formPayload.excerpt" type="text" class="form-control"
                :class="validations.hasOwnProperty('excerpt') && validations.excerpt.length > 0 ? 'is-invalid' : ''"
                placeholder="excerpt" />
            <small v-if="validations.hasOwnProperty('excerpt') && validations.excerpt.length > 0" class="text-danger">
                {{ validations.excerpt.join(', ') }}
            </small>
        </div>

        <div class="form-group">
            <label for="content">Content: <span class="text-danger">*</span></label>
            <!-- <Editor v-model="formPayload.content" :api-key="apiKeyTinyMce" :init="initTiny">
            </Editor> -->
            <quill-editor id="content" v-model="formPayload.content" :options="editorOption"
                ref="quillEdit" @ready="onEditorReady" />
            <small v-if="validations.hasOwnProperty('excerpt') && validations.excerpt.length > 0" class="text-danger">
                {{ validations.excerpt.join(', ') }}
            </small>
        </div>

        <div class="form-group">
            <label for="category">Category: <span class="text-danger">*</span></label>
            <v-select id="category" v-model="formPayload.category" :options="options.optionsCategory"
                :reduce="item => item.uuid" label="name" placeholder="Type to search category..."
                @search="onSearchCategory">
                <template slot="no-options">
                    Type here to search category...
                </template>
            </v-select>
        </div>

        <b-row>
            <b-col>
                <div class="form-group d-flex align-items-center">
                    <label class="mr-25" for="editor-selected">Editor Selected: <span
                            class="text-danger">*</span></label>
                    <b-form-checkbox id="editor-selected" v-model="formPayload.is_editor_selected"
                        class="custom-control-primary" />
                </div>
                <small
                    v-if="validations.hasOwnProperty('is_editor_selected') && validations.is_editor_selected.length > 0"
                    class="text-danger">
                    {{ validations.is_editor_selected.join(', ') }}
                </small>
            </b-col>
            <b-col>
                <div class="form-group d-flex align-items-center">
                    <label class="mr-25" for="is_headline">Headline: <span class="text-danger">*</span></label>
                    <b-form-checkbox v-model="formPayload.is_headline" class="custom-control-primary" />
                </div>
                <small v-if="validations.hasOwnProperty('is_headline') && validations.is_headline.length > 0"
                    class="text-danger">
                    {{ validations.is_headline.join(', ') }}
                </small>
            </b-col>
        </b-row>

        <div class="form-group">
            <label for="status">Status: <span class="text-danger">*</span></label>
            <b-form-select :options="options.optionsStatus" id="status" v-model="formPayload.status"
                class="form-control"
                :class="validations.hasOwnProperty('status') && validations.status.length > 0 ? 'is-invalid' : ''" />
            <small v-if="validations.hasOwnProperty('status') && validations.status.length > 0" class="text-danger">
                {{ validations.status.join(', ') }}
            </small>
        </div>

        <div class="form-group">
            <label for="published_at">Published At: <span class="text-danger">*</span></label>
            <flat-pickr v-model="formPayload.published_at" class="form-control"
                :config="{ enableTime: true, dateFormat: 'Y-m-d H:i:ss' }" />
            <small v-if="validations.hasOwnProperty('published_at') && validations.published_at.length > 0"
                class="text-danger">
                {{ validations.published_at.join(', ') }}
            </small>
        </div>

        <div class="form-group" v-if="userData.role == 'admin'">
            <label for="partner">Partner: <span class="text-danger">*</span></label>
            <v-select id="partner" v-model="formPayload.partner" :options="options.optionsPartner"
                :reduce="item => item.uuid" label="name" placeholder="Type to search Partner..."
                @search="onSearchPartner">
                <template slot="no-options">
                    Type here to search partner...
                </template>
            </v-select>
        </div>

        <div class="form-group">
            <label for="author">Author: <span class="text-danger">*</span></label>
            <v-select id="author" v-model="formPayload.author" :options="options.optionsAuthor"
                :reduce="item => item.uuid" label="name" placeholder="Type to search Author..."
                @search="onSearchAuthor">
                <template slot="no-options">
                    Type here to search Author...
                </template>
            </v-select>
        </div>

        <div class="form-group">
            <label for="content_type">Content Type: <span class="text-danger">*</span></label>
            <b-form-select :options="options.optionsContentType" id="content_type" v-model="formPayload.content_type"
                class="form-control"
                :class="validations.hasOwnProperty('content_type') && validations.content_type.length > 0 ? 'is-invalid' : ''" />
            <small v-if="validations.hasOwnProperty('content_type') && validations.content_type.length > 0"
                class="text-danger">
                {{ validations.content_type.join(', ') }}
            </small>
        </div>

        <div class="form-group">
            <label for="tags">Tags:</label>
            <b-form-tags v-model="formPayload.tags" input-id="tags-basic"
                :class="validations.hasOwnProperty('tags') && validations.tags.length > 0 ? 'is-invalid' : ''" />
            <small v-if="validations.hasOwnProperty('tags') && validations.tags.length > 0" class="text-danger">
                {{ validations.tags.join(', ') }}
            </small>
        </div>

        <div class="form-group">
            <label for="keywords">Keywords:</label>
            <b-form-tags id="keywords" v-model="formPayload.keywords" input-id="tags-website-keywords" class="mb-2"
                placeholder="Add website keywords" />
            <small v-if="validations.hasOwnProperty('keywords') && validations.keywords.length > 0" class="text-danger">
                {{ validations.keywords.join(', ') }}
            </small>
        </div>

        <div class="form-group" v-if="formPayload.content_type === 'video'">
            <label for="youtube_id">Youtube ID: </label>
            <b-form-input id="youtube_id" v-model="formPayload.youtube_id" type="text" class="form-control"
                :class="validations.hasOwnProperty('youtube_id') && validations.youtube_id.length > 0 ? 'is-invalid' : ''"
                placeholder="Thumbnails are automatically generated from YouTube" />
            <a class="my-2" :href="`/how-to-get-youtube_id.png`" target="_blank">
                How to get youtube id
            </a>
            <small v-if="validations.hasOwnProperty('youtube_id') && validations.youtube_id.length > 0"
                class="text-danger">
                {{ validations.youtube_id.join(', ') }}
            </small>
        </div>

        <div class="d-flex align-items-center">
            <div v-if="isLoading" class="mr-1">
                <b-spinner variant="primary" /><br>
            </div>
            <b-button id="save-item" v-if="editId == null" variant="success" :disabled="isLoading"
                @click="createItem()">
                Save Item
            </b-button>
            <b-button id="save-item" v-else variant="success" :disabled="isLoading" @click="updateItem()">
                Save Item
            </b-button>
        </div>
    </b-card>
</template>

<script>
import _ from 'lodash'
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
    BButton, BSpinner, BFormInput, BFormFile, BRow, BCol, BForm, BFormTextarea, BFormSelect, BFormCheckbox, BFormTags, BCard, BImg,
} from 'bootstrap-vue'
import { heightTransition } from '@core/mixins/ui/transition'
import Ripple from 'vue-ripple-directive'

import { successNotification, errorNotification } from '@/auth/utils'
import vSelect from 'vue-select'

// eslint-disable-next-line
import 'quill/dist/quill.core.css'
// eslint-disable-next-line
import 'quill/dist/quill.snow.css'
// eslint-disable-next-line
import 'quill/dist/quill.bubble.css'
import { quillEditor, Quill } from 'vue-quill-editor'
import YoutubeBlob from '@/utils/YoutubeBlob'
Quill.register(YoutubeBlob)

import flatPickr from 'vue-flatpickr-component'

import { formatDate } from '@/utils/date'

import Editor from '@tinymce/tinymce-vue'

import '@/utils/PageBreakBlot'
import '@/utils/InstagramBlot'

import moment from 'moment'

export default {
    title() {
        return 'Detail Post Management'
    },
    components: {
        BCard,
        BButton,
        BCardCode,
        BSpinner,
        BFormInput,
        BFormFile,
        BRow,
        BCol,
        BForm,
        BFormTextarea,
        vSelect,
        BFormSelect,
        BFormCheckbox,
        quillEditor,
        BFormTags,
        flatPickr,
        BImg,
        Editor
    },
    directives: {
        Ripple,
    },
    setup() {
        return { successNotification, errorNotification, formatDate }
    },
    mixins: [heightTransition],
    data() {
        const userData = JSON.parse(localStorage.getItem('userData'))
        const apiKeyTinyMce = process.env.API_KEY_TINY_MCE
        const publishDate = moment(new Date).format('YYYY-MM-DD hh:mm:ss')
        return {
            apiKeyTinyMce,
            initTiny: {
                plugins: ['advlist', 'autolink', 'lists', 'link', 'charmap', 'preview',
                    'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                    'insertdatetime', 'media', 'table', 'help', 'wordcount', 'image code', 'pagebreak'],
                // toolbar: 'customInsertButton',
                toolbar: [
                    'undo redo | styles | bold italic | link image alignleft aligncenter alignright customInsertButton'
                ],
                image_title: true,
                automatic_uploads: true,
                file_picker_types: 'image',
                file_picker_callback: this.handleImageUpload,
                setup: this.setupTiny,
                pagebreak_split_block: true
            },
            userData,
            // Quil Editor
            editorOption: {
                modules: {
                    toolbar: {
                        container: [
                            ['bold', 'italic', 'underline', 'strike'],
                            ['blockquote', 'code-block'],
                            ['link', 'image', 'video', 'formula'],

                            [{ 'header': 2 }],
                            [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'list': 'check' }],
                            [{ 'script': 'sub' }, { 'script': 'super' }],
                            [{ 'indent': '-1' }, { 'indent': '+1' }],
                            [{ 'direction': 'rtl' }],

                            [{ 'size': ['small', false, 'large', 'huge'] }],
                            [{ 'header': [2, 3, 4, 5, 6, false] }],

                            [{ 'color': [] }, { 'background': [] }],
                            [{ 'font': [] }],
                            [{ 'align': [] }],

                            ['clean'],
                            ['pageBreak'],
                            ['instagram'],
                        ],
                        handlers: {
                            image: this.imageHandler, // Custom image handler
                            pageBreak: this.pageBreakHandler,
                            instagram: this.insertInstagramEmbed,
                            video: this.videoHandler,
                        },
                    },
                },
            },

            result: Object,
            isLoading: false,
            formPayload: {
                title: '',
                category: '',
                excerpt: '',
                content: '',
                is_editor_selected: false,
                is_headline: false,
                status: 'publish',
                tags: [],
                published_at: publishDate,
                partner: null,
                author: null,
                content_type: 'standard',
                thumbnail: null,
                youtube_id: null,
                video: null,
                keywords: [],
                thumbnail_description: '',
                thumbnail_source: '',
                thumbnail_author: '',
            },
            previewImage: null,
            previewVideo: null,
            editId: null,
            filter: {
                search: '',
            },
            validations: {},
            options: {
                optionsAuthor: [],
                optionsPartner: [],
                optionsCategory: [],
                optionsStatus: [
                    {
                        value: '',
                        text: 'Choose status',
                    },
                    {
                        value: 'publish',
                        text: 'Publish',
                    },
                    {
                        value: 'draft',
                        text: 'Draft',
                    },
                    {
                        value: 'scheduled',
                        text: 'Scheduled',
                    },
                ],
                optionsContentType: [
                    {
                        value: null,
                        text: 'Choose content type',
                    },
                    {
                        value: 'standard',
                        text: 'Standard',
                    },
                    {
                        value: 'video',
                        text: 'Video',
                    },
                ]
            }
        }
    },
    mounted() {
        this.getData()
        this.getCategory()
        this.getPartner()
        this.getAuthor()
    },
    created() {
    },
    destroyed() {
    },
    watch: {
        // 'formPayload.published_at': {
        //     handler(value) {
        //         console.log(value, 'PUBLISH DATE');
        //     },
        //     deep: true,
        // }
    },
    methods: {
        insertInstagramEmbed() {
            // Method 1: Get Instagram URL from user
            const instagramUrl = prompt('Enter Instagram post URL:');
            
            if (instagramUrl && instagramUrl.includes('instagram.com')) {
                const range = this.quill.getSelection(true);
                if (range) {
                    // Insert the Instagram embed
                    this.quill.insertEmbed(range.index, 'instagram', instagramUrl, 'user');
                    this.quill.setSelection(range.index + 1);
                    
                    // Load Instagram script to render embeds
                    this.loadInstagramScript();
                }
            } else if (instagramUrl) {
                errorNotification(this, 'Oops!', 'Please enter a valid Instagram URL')
            }
        },
        videoHandler() {
            const url = prompt('Enter Video/Audio URL (YouTube or Spotify)')
            if (url) {
                let embedUrl = url
                
                // YouTube
                const videoIdMatch = url.match(/(?:\?v=|\/embed\/|\.be\/)([^&?]+)/)
                if (videoIdMatch) {
                    embedUrl = 'https://www.youtube.com/embed/' + videoIdMatch[1]
                } 
                // Spotify
                else if (url.includes('open.spotify.com')) {
                    // Convert https://open.spotify.com/track/ID to https://open.spotify.com/embed/track/ID
                    // Also handles album, playlist, artist etc.
                    embedUrl = url.replace('open.spotify.com', 'open.spotify.com/embed')
                }

                // If selection is null, focus the editor first
                if (!this.quill.getSelection()) {
                    this.quill.focus()
                }

                // Get selection range; if null (still), default to 0 (start of doc) or length
                const range = this.quill.getSelection() || { index: this.quill.getLength() }
                
                this.quill.insertEmbed(range.index, 'video', embedUrl)
            }
        },

        // Alternative method: Insert full Instagram embed code
        insertInstagramEmbedCode() {
            const embedCode = prompt('Paste Instagram embed code here:');
            
            if (embedCode && embedCode.includes('instagram-media')) {
                // Clean the embed code
                const cleanEmbed = embedCode
                    .replace(/^\s*["']|["']\s*$/g, '') // Remove quotes at start/end
                    .replace(/>\s*$/, '>') // Remove trailing whitespace after >
                    .replace(/>\s*"[^"]*$/, '>'); // Remove any trailing quote fragments
                
                const range = this.quill.getSelection(true);
                if (range) {
                    this.quill.insertEmbed(range.index, 'instagram', cleanEmbed, 'user');
                    this.quill.setSelection(range.index + 1);
                    this.loadInstagramScript();
                }
            }
        },
        loadInstagramScript() {
            // Check if script is already loaded
            if (!document.querySelector('script[src*="instagram.com/embed.js"]')) {
                const script = document.createElement('script');
                script.async = true;
                script.src = '//www.instagram.com/embed.js';
                document.head.appendChild(script);
            } else if (window.instgrm) {
                // If script already exists, just process embeds
                window.instgrm.Embeds.process();
            }
        },
        validateTitle() {
            if (!this.validations.title) {
                this.$set(this.validations, 'title', []);
            }
            
            this.validations.title = [];
            
            if (this.formPayload.title && this.formPayload.title.length > 500) {
                this.validations.title.push('Title must not exceed 500 characters');
            }
        },
        pageBreakHandler() {
            const range = this.quill.getSelection(true);
            if (range) {
                this.quill.insertEmbed(range.index, 'pageBreak', true, 'user');
                this.quill.setSelection(range.index + 1);
            }
        },
        setupTiny(editor) {
            editor.ui.registry.addButton('customInsertButton', {
                text: 'Disclaimer',
                onAction: (_) => editor.insertContent(`&nbsp;<strong>Disclaimer!</strong>&nbsp;`)
            });
        },
        // Author
        onSearchAuthor(search, loading) {
            if (search.length) {
                loading(true)
                this.searchAuthor(loading, search, this)
            }
        },
        searchAuthor: _.debounce((loading, search, vm) => {
            vm.$http.get(`admin/users/pagination?&search=${encodeURI(search)}`)
                .then(response => {
                    vm.options.optionsAuthor = response.data.data.items.map(obj => ({
                        uuid: obj._id,
                        name: obj.name,
                    }))
                })
                .catch(error => {
                    console.error(error)
                })
            loading(false)
        }, 300),
        getAuthor() {
            this.$http.get('/admin/users/pagination', {
            }).then((result) => {
                this.options.optionsAuthor = result.data.data.items.map(obj => ({
                    uuid: obj._id,
                    name: obj.name,
                }))
            }).catch((err) => {

            });
        },
        // Partner
        onSearchPartner(search, loading) {
            if (search.length) {
                loading(true)
                this.searchPartner(loading, search, this)
            }
        },
        searchPartner: _.debounce((loading, search, vm) => {
            vm.$http.get(`admin/partners?&search=${encodeURI(search)}`)
                .then(response => {
                    vm.options.optionsPartner = response.data.data.items.map(obj => ({
                        uuid: obj._id,
                        name: obj.name,
                    }))
                })
                .catch(error => {
                    console.error(error)
                })
            loading(false)
        }, 300),
        getPartner() {
            if (this.userData.role == 'admin') {
                this.$http.get('/admin/partners', {
                }).then((result) => {
                    this.options.optionsPartner = result.data.data.items.map(obj => ({
                        uuid: obj._id,
                        name: obj.name,
                    }))
                }).catch((err) => {

                });
            }
        },
        // Category
        onSearchCategory(search, loading) {
            if (search.length) {
                loading(true)
                this.searchCategry(loading, search, this)
            }
        },
        searchCategry: _.debounce((loading, search, vm) => {
            vm.$http.get(`admin/post-categories?search=${encodeURI(search)}`)
                .then(response => {
                    vm.options.optionsCategory = response.data.data.items.map(obj => ({
                        uuid: obj._id,
                        name: obj.name,
                    }))
                })
                .catch(error => {
                    console.error(error)
                })
            loading(false)
        }, 300),
        getCategory() {
            this.$http.get(`admin/post-categories`, {
                params: {
                    limit: 100
                }
            })
                .then(response => {
                    this.options.optionsCategory = response.data.data.items.map(obj => ({
                        uuid: obj._id,
                        name: obj.name,
                    }))
                })
                .catch(error => {
                    console.error(error)
                })
        },
        cleanUpForm() {
            this.editId = null
            this.formPayload = {
                title: '',
                category: '',
                excerpt: '',
                content: '',
                is_editor_selected: false,
                is_headline: false,
                status: '',
                tags: [],
                published_at: '',
                partner: null,
                author: null,
                content_type: null,
                thumbnail: null,
                youtube_id: null,
                video: null,
                keywords: [],
                thumbnail_description: '',
                thumbnail_source: '',
                thumbnail_author: '',
            }
        },
        getData() {
            if (this.$route.params.id) {
                this.$http.get(`admin/posts/${this.$route.params.id}`).then((result) => {
                    const { title, category, partner, author, thumbnail, video, youtube_id, excerpt, content, content_type, is_editor_selected, is_headline, tags, status, published_at, keywords, thumbnail_description, thumbnail_source, thumbnail_author } = result.data.data
                    this.editId = this.$route.params.id

                    this.formPayload = {
                        title: title,
                        category: category?._id,
                        excerpt: excerpt,
                        content: content,
                        is_editor_selected: is_editor_selected,
                        is_headline: is_headline,
                        status: status,
                        tags: tags,
                        published_at: published_at,
                        partner: partner?._id,
                        author: author?._id,
                        content_type: content_type,
                        youtube_id: youtube_id,
                        keywords: keywords || [],
                        thumbnail_description,
                        thumbnail_source,
                        thumbnail_author,
                    }
                    this.previewImage = thumbnail
                    this.previewVideo = video
                }).catch((err) => {

                });
            }
        },
        createItem() {
            this.isLoading = true
            const form = this.preparePayload()

            this.$http.post('/admin/posts', form, {
                headers: { "Content-Type": "multipart/form-data" },
            })
                .then(response => {
                    this.isLoading = false
                    this.$bvModal.hide('form-modal')
                    this.getData(this.currentPage)
                    successNotification(this, 'Success', 'Posts successfully created')
                    this.cleanUpForm()
                    this.$router.push({ name: 'posts' })
                })
                .catch(error => {
                    this.isLoading = false
                    const validations = error.response.data.meta.validations
                    const messages = error.response.data.meta.messages
                    // this.validations = validations
                    if (validations) {
                        for (const key in validations) {
                            if (validations.hasOwnProperty(key)) {
                                errorNotification(this, 'Oops!', key + ' ' + validations[key].join(', '))
                            }
                        }
                    }
                    if (messages) {
                        errorNotification(this, 'Oops!', messages)
                    }
                })
        },
        updateItem() {
            this.isLoading = true
            const form = this.preparePayload()

            this.$http.patch(`/admin/posts/${this.editId}`, form, {
                headers: { "Content-Type": "multipart/form-data" },
            })
                .then(response => {
                    this.isLoading = false
                    this.$bvModal.hide('form-modal')
                    this.getData(this.currentPage)
                    successNotification(this, 'Success', 'Posts successfully updated!')
                    this.cleanUpForm()
                    this.$router.push({ name: 'posts' })
                })
                .catch(error => {
                    this.isLoading = false
                    const validations = error.response.data.meta.validations
                    const messages = error.response.data.meta.messages
                    // this.validations = validations
                    if (validations) {
                        for (const key in validations) {
                            if (validations.hasOwnProperty(key)) {
                                errorNotification(this, 'Oops!', key + ' ' + validations[key].join(', '))
                            }
                        }
                    }
                    if (messages) {
                        errorNotification(this, 'Oops!', messages)
                    }
                })
        },
        preparePayload() {
            const form = new FormData()

            // Clean the content before saving
            let cleanContent = this.formPayload.content;
            
            // Remove any stray quote characters or malformed HTML
            cleanContent = cleanContent
            .replace(/>\s*["']\s*>/g, '>') // Remove quotes between tags
            .replace(/>\s*["'][^"'<]*$/g, '>') // Remove trailing quote fragments
            .replace(/"\s*>$/gm, '">'); // Fix malformed closing quotes

            // Update the content
            this.formPayload.content = cleanContent;

            // eslint-disable-next-line no-restricted-syntax
            for (const key in this.formPayload) {
                if (this.formPayload.hasOwnProperty(key) && this.formPayload[key] !== 'null' && this.formPayload[key] !== null) {
                    // Handle if this.formPayload[key] is array
                    if (key != 'tags' && key != 'keywords') {
                        form.append(key, this.formPayload[key])
                    }
                    if (key == 'tags') {
                        for (let index = 0; index < this.formPayload[key].length; index++) {
                            const element = this.formPayload[key][index];
                            form.append(`${key}[${index}]`, element)
                        }
                    }
                    if (key == 'keywords') {
                        if (Array.isArray(this.formPayload.keywords)) {
                            this.formPayload.keywords.forEach((element, index) => {
                                form.append(`${key}[${index}]`, element);
                            });
                        }
                    }
                }
            }

            return form
        },
        async changeImage(event) {
            try {
                const files = event.target.files[0];
                
                if (files) {
                // Check file size (2MB = 2 * 1024 * 1024 bytes)
                const maxSize = 2 * 1024 * 1024; // 2MB in bytes
                
                if (files.size > maxSize) {
                    errorNotification(this, 'Oops!', 'Image size must be less than 2MB. Please choose a smaller image.')
                    // Clear the input
                    event.target.value = '';
                    return;
                }
                
                // Optional: Check if it's actually an image
                if (!files.type.startsWith('image/')) {
                    errorNotification(this, 'Oops!', 'Please select a valid image file.')
                    event.target.value = '';
                    return;
                }
                
                this.formPayload.thumbnail = files;
                }
            } catch (error) {
                console.log(error);
            }
        },
        async changeVideo(event) {
            try {
                const files = event.target.files[0]
                this.formPayload.video = files
            } catch (error) {
                console.log(error);
            }
        },
        onEditorReady(editor) {
            // Keep a reference to the editor instance
            this.quill = editor;
        },
        handleImageUpload(cb, value, meta) {
            const input = document.createElement('input');
            input.setAttribute('type', 'file');
            input.setAttribute('accept', 'image/*');

            input.addEventListener('change', async (e) => {
                const file = e.target.files[0];
                if (file) {
                    const fileUploadPayload = new FormData();
                    fileUploadPayload.append('file', file);
                    try {
                        const uploadToServer = await this.$http.post("/admin/upload-files", fileUploadPayload, {
                            headers: { "Content-Type": "multipart/form-data" },
                        });
                        const uploadToServerResponse = uploadToServer.data.data.file_url;
                        cb(uploadToServerResponse, { title: file.name });
                        // setTimeout(() => {
                        //     success(uploadToServerResponse)
                        // }, 3000);
                    } catch (error) {
                        console.log('Error upload image :', error);
                        // errorNotification(this, `Upload file ${blobInfo.name()} error`);
                    }
                }


            });

            input.click();
        },
        imageHandler() {
            const input = document.createElement('input');
            input.setAttribute('type', 'file');
            input.setAttribute('accept', 'image/*');
            input.click();

            input.onchange = async () => {
                const file = input.files[0];
                if (file) {
                    /**
                     * Upload file to Server
                     */
                    const fileUploadPayload = new FormData();
                    fileUploadPayload.append('file', file);
                    try {
                        const uploadToServer = await this.$http.post("/admin/upload-files", fileUploadPayload, {
                            headers: { "Content-Type": "multipart/form-data" },
                        });
                        const uploadToServerResponse = uploadToServer.data.data.file_url;
                        const range = this.quill.getSelection();
                        setTimeout(() => {
                            console.log('set image');
                            this.quill.insertEmbed(range.index, 'image', uploadToServerResponse);
                        }, 3000);
                    } catch (error) {
                        console.log('Error quiil upload image :', error);
                        errorNotification(this, `Upload file ${file.name} error`);
                    }
                }
            };
        },
    },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.page-break {
  border: none;
  border-top: 2px dashed #999;
  margin: 2em 0;
}
.ql-pageBreak {
  min-width: 80px; /* Or any desired width */
  padding: 4px 8px;
  background-color: #f3f4f6; /* Optional: light background */
  border-radius: 4px;
  border: 1px solid #ccc;
  margin-left: 5px;
  cursor: pointer;
}

.ql-pageBreak::after {
  content: 'Page Break'; /* Label text */
  font-size: 12px;
  font-weight: 500;
  color: #333;
}
.ql-toolbar .ql-instagram {
  min-width: 80px;
  
  &::before {
    content: 'Instagram'; // Instagram camera emoji
    font-size: 13px;
    font-weight: 500;
    color: #333;
  }
}

.ql-toolbar .ql-instagram:hover {
  background-color: #f0f0f0;
}

// Instagram embed in editor
.ql-editor .instagram-media {
  border: 1px solid #dbdbdb;
  border-radius: 3px;
  padding: 16px;
  margin: 16px 0;
  background-color: #fff;
  max-width: 540px;
  min-height: 150px;
  
  &::before {
    content: 'Instagram Post';
    display: block;
    font-weight: bold;
    color: #262626;
    margin-bottom: 8px;
  }
  
  a {
    color: #003569;
    text-decoration: none;
    
    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
